import styled from '@emotion/styled';

import { fromTheme } from '@kyruus/ui-theme';
import Chip from '@kyruus/chip';
import {
  getBackgroundColorFromVariant,
  getBorderColorFromVariant
} from '@kyruus/provider-components';

export const LocationName = styled.h1`
  font-size: ${fromTheme('font_size_heading_1')};
  font-family: ${fromTheme('font_face')};
  color: ${fromTheme('color_text')};
  line-height: ${fromTheme('font_line_height')};
  margin: ${fromTheme('spacing_medium')} 0 ${fromTheme('spacing_small')};
`;

export const LocationAddress = styled.div`
  margin-top: ${fromTheme('spacing_medium')};
  font-size: ${fromTheme('font_size_heading_5')};
  color: ${fromTheme('color_text')};
  font-family: ${fromTheme('font_face')};
  line-height: ${fromTheme('font_line_height')};
`;

export const LocationChipsContainer = styled('div')`
  margin-top: ${fromTheme('spacing_medium')};
  display: flex;
  flex-wrap: wrap;
  gap: ${fromTheme('spacing_xsmall')};
`;

export const LocationChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'color'
})`
  && {
    color: ${fromTheme('color_text_contrast')};
    background-color: ${({ color, ...restProps }) =>
      getBackgroundColorFromVariant(color, restProps)};
    border-color: ${({ color, ...restProps }) =>
      getBorderColorFromVariant(color, restProps)};
    border-radius: ${fromTheme('border_radius_badge_chip')};
    border-width: ${fromTheme('border_width')};
    border-style: ${fromTheme('border_style')};
    font-family: ${fromTheme('font_face')};
    font-size: ${fromTheme('font_size')};
    font-weight: ${fromTheme('font_weight')};
    margin-right: ${fromTheme('spacing_small')};
    line-height: ${fromTheme('font_line_height')};
  }
`;
